import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['logo', 'navBarBoxShadow'];

    connect()
    {
        let backToTopButton = document.querySelector('.back_top_button');
        this.element.style.height = `${this.calculateHeaderHeightFromPosition(this.getScrollPercentage())}px`;
        this.logoTarget.style.width = `${this.calculateLogoWidthFromPosition(this.getScrollPercentage())}px`;
        if (window.scrollY !== 0) this.navBarBoxShadowTarget.style.opacity = 1;
        this.showBackTotopButton(backToTopButton);

        document.addEventListener('scroll', () => {
            let scrollPercentage = this.getScrollPercentage();
            this.element.style.height = `${this.calculateHeaderHeightFromPosition(scrollPercentage)}px`;
            this.logoTarget.style.width = `${this.calculateLogoWidthFromPosition(this.getScrollPercentage())}px`;
            if (window.scrollY !== 0)
            {
                this.navBarBoxShadowTarget.style.opacity = 1;
            }
            else
            {
                this.navBarBoxShadowTarget.style.opacity = 0;
            }
            this.showBackTotopButton(backToTopButton);
        })
    }

    getScrollPercentage()
    {
        let docHeight = document.body.offsetHeight;
        let scrollTop = window.scrollY;
        let winHeight = window.innerHeight;

        return Math.round((scrollTop / (docHeight - winHeight)) * 100) > 100 ? 100 : Math.round((scrollTop / (docHeight - winHeight)) * 100);
    }

    calculateHeaderHeightFromPosition(scrollPercentage)
    {
        //150 height de référence de 150px (height maximale) et 60 pour height minimale
        return 150 - Math.round((scrollPercentage / 100) * 150) < 60 ? 60 : 150 - Math.round((scrollPercentage / 100) * 150);
    }

    calculateLogoWidthFromPosition(scrollPercentage)
    {
        //350 width de référence de 350px (width maximale) et 140 pour width minimale
        return 350 - Math.round((scrollPercentage / 100) * 350) < 140 ? 140 : 350 - Math.round((scrollPercentage / 100) * 350);
    }

    showBackTotopButton(button)
    {
        if (this.getScrollPercentage() === 100)
        {
            button.style.transform = "translate3d(0px, 0px, 0px)";
            button.style.opacity = 1;
        }
        else
        {
            button.style.transform = "translate3d(-100px, 0px, 0px)";
            button.style.opacity = 0;
        }
    }
}